define(function (require) {
    "use strict";

    var LE = require("app");

    var AgentGroupListComparators = [];

    function moduleDefinition (LEUserManagement, LE, Backbone, Marionette, $, _) {
        //I wish these comparators where mre straight forward, alas AS user Model,AC user model may have different property names
        AgentGroupListComparators = [
            {
                name:"name",
                func:function(model){
                    return model.getName().toLowerCase();
                }
            },
            {
                name:"parentGroup",
                func:function(model){
                    var parentGroupId = model.getParentGroupId();
                    var parentGroupName = "";
                    var parentGroupModel = LEUserManagement.getDataManager().getAgentGroupsCollection().get(parentGroupId);
                    if (parentGroupModel) {
                        parentGroupName = parentGroupModel.getName();
                    }
                    return parentGroupName;
                }
            },
            {
                name: "members",
                func: function(model) {
                    return model.getMembers().length;
                }
            },
            {
                name: "subGroups",
                func: function(model) {
                    return model.getSubGroups().length;

                }
            }

        ];
    }

    LE.module("LEUserManagement", moduleDefinition);

    return AgentGroupListComparators;
});
